import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface HtmlLoaderOptions extends AjaxLoaderOptions {
    position?: InsertPosition | "inner";
    target?: HTMLElement | string;
}

export class HtmlLoader extends AbstractAjaxLoader<HTMLElement, HtmlLoaderOptions>{
    public async convert(text: string): Promise<any> {
        var target: HTMLElement = null;
        if (this._options.target !== undefined) {
            if (typeof this._options.target === "string") {
                target = document.querySelector(this._options.target);
            } else {
                target = this._options.target;
            }
        } else {
            target = document.createElement("div");
        }
        if (this._options.position === "inner") {
            target.innerHTML = text;
        } else {
            target.insertAdjacentHTML(this._options.position, text);
        }
        return target;
    }

    protected defaultOptions(): HtmlLoaderOptions {
        return {
            decoder: "text",
            position: "inner"
        }
    }
}

registerLoader("html", HtmlLoader);